module.exports = __webpack_public_path__ + "static/img/icon-jpg_filled.8d6eb330.svg";